import { create, type StateCreator } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export interface DarkModeSlice {
    darkMode: boolean
}

export const createDarkModeSlice: StateCreator<DarkModeSlice, [], [], DarkModeSlice> = () => ({
    darkMode: false,
})

export const useDarkModeStore = create<DarkModeSlice>()(
    persist(
        devtools(createDarkModeSlice as any, {
            name: 'DarkModeStore',
        }),
        { name: 'dark-mode' },
    ),
)

export const useDarkMode = () => useDarkModeStore((state) => state.darkMode)
export const getDarkModeState = () => useDarkModeStore.getState().darkMode
export const setDarkMode = (state: boolean) => useDarkModeStore.setState({ darkMode: state })
export const toggleDarkMode = () => setDarkMode(!getDarkModeState())
